<template>
	<div class="home-content">
		<div class="shop-box">
			店铺数统计月份：
			<el-date-picker
				v-model="month"
				type="month"
				size="small"
				@change="handleMonth"
				:picker-options="pickerOptions"
				placeholder="选择月"
			>
			</el-date-picker>
			<span class="ml20">新开店铺数：</span>{{ newCnt }}
			<span class="ml20">闭店数：</span>{{ closeCnt }}
			<span class="ml20">配送店铺数：</span>{{ deliveryCnt }}
			<span class="ml20">当前店铺数：</span>{{ allCnt }}
		</div>
		<div class="home-grid">
			<div class="div">
				<div class="title">
					<img src="@/assets/images/8.png" alt="" />
					路线管理
				</div>
				<div
					class="text"
					v-if="perms.includes('m_route_set')"
					@click="handleRoute('route')"
				>
					<span class="dot1"></span>路线
				</div>
				<div
					class="text"
					v-if="perms.includes('m_route_map')"
					@click="handleRoute('map')"
				>
					<span class="dot1"></span>路线地图
				</div>
				<div
					class="text"
					v-if="perms.includes('m_round_set')"
					@click="handleRoute('tour')"
				>
					<span class="dot1"></span>巡回计划
				</div>
			</div>
			<div class="div">
				<div class="title">
					<img src="@/assets/images/9.png" alt="" />
					业务数据
				</div>
				<div
					class="text"
					v-if="perms.includes('m_order')"
					@click="handleRoute('merchantOrder')"
				>
					<span class="dot1"></span>客商订单
				</div>
				<div
					class="text"
					v-if="perms.includes('m_receipt')"
					@click="handleRoute('collectionOrder')"
				>
					<span class="dot1"></span>收款单
				</div>
				<div
					class="text"
					v-if="perms.includes('m_load_vehicle')"
					@click="handleRoute('shipOrder')"
				>
					<span class="dot1"></span>装车单
				</div>
				<div
					class="text"
					v-if="perms.includes('m_store_check')"
					@click="handleRoute('vividCheck')"
				>
					<span class="dot1"></span>生动化检查
				</div>
				<div
					class="text"
					v-if="perms.includes('m_agent_stock')"
					@click="handleRoute('agentStock')"
				>
					<span class="dot1"></span>客商库存
				</div>
				<div
					class="text"
					v-if="perms.includes('m_other_out')"
					@click="handleRoute('otherOrder')"
				>
					<span class="dot1"></span>其它出库单
				</div>

				<div
					class="text"
					v-if="perms.includes('m_signin')"
					@click="handleRoute('signForm')"
				>
					<span class="dot1"></span>签到拜访表
				</div>
			</div>
			<div class="div">
				<div class="title">
					<img src="@/assets/images/10.png" alt="" />
					业务报表
				</div>
				<div
					class="text"
					v-if="perms.includes('m_round_report')"
					@click="handleRoute('tourDaily')"
				>
					<span class="dot1"></span>巡回日报
				</div>
				<div
					class="text"
					v-if="perms.includes('m_agent_book')"
					@click="handleRoute('saleAccount')"
				>
					<span class="dot1"></span>销售台账
				</div>
				<div
					class="text"
					v-if="perms.includes('m_agent_sale_book')"
					@click="handleRoute('merchantAccount')"
				>
					<span class="dot1"></span>客商台账
				</div>
			</div>
			<div class="div tip-info-box">
				<div class="title">
					<img src="@/assets/images/11.png" alt="" />
					提示
				</div>
				<div class="tips-box">
					<!--  -->
					<div
						class="tips-item flex flex-between"
						v-for="(item, index) in infoList"
						:key="index"
					>
						<div class="flex">
							<img class="" src="@/assets/images/12.png" alt="" />
							<span class="ml10"
								>{{ item.accountName }}预付款账号余额不足</span
							>
						</div>
						<!-- <div class="tips-time">2分钟前</div> -->
					</div>
					<!--  -->
				</div>
				<div class="tc tips-content">
					<el-pagination
						background
						:current-page="pageNo"
						:page-size="pageSize"
						layout="prev, pager, next"
						@current-change="handleCurrentPage"
						:total="total"
					>
					</el-pagination>
				</div>
				<div class="pdf-box flex flex-middle">
					<div class="pdf-item">
						<a
							target="_blank"
							href="https://msslx.yakult.com.cn/files/download/operate/yakult-operation-manual(PC).pdf"
						>
							<img
								class="pdf-img"
								src="@/assets/images/pdf.png"
								alt=""
							/>
							<div>PC管理后台操作手册</div>
						</a>
					</div>
					<div class="pdf-item">
						<!-- UAT测试 -->
						<img v-if="uatFlag" class="code-img" src="@/assets/images/testCode.png" alt=""/>
						<!-- 正式 -->
						<img v-else class="code-img" src="@/assets/images/code.png" alt=""/>
					</div>
					<div class="pdf-item">
						<a
							target="_blank"
							href="https://msslx.yakult.com.cn/files/download/operate/yakult-operation-manual(mobile).pdf"
						>
							<img
								class="pdf-img"
								src="@/assets/images/pdf.png"
								alt=""
							/>
							<div>手机端操作手册</div>
						</a>
					</div>
				</div>
			</div>
		</div>

	</div>
</template>
<script>
// 引入配置文件
const defaultSettings = require('@/settings.js');
export default {
	data() {
		return {
			perms: window.sessionStorage.getItem("perms"),
			infoList: [],
			pageNo: 1,
			pageSize: 5,
			total: 0,
			month: `${new Date().getFullYear()}-${String(
				new Date().getMonth() + 1
			).padStart(2, 0)}`,
			// 当前店铺数
			allCnt: 0,
			// 新开店铺数
			newCnt: 0,
			// 闭店数
			closeCnt: 0,
			// 配送店铺数
			deliveryCnt: 0,
			pickerOptions: {
				// 仅允许选择最近12个月
				disabledDate: date => {
					const cdate = new Date();
					return (
						cdate.getTime() - 1000 * 60 * 60 * 24 * 365 > date.getTime() || date.getTime() > cdate.getTime()
					);
				}
			},
			uatFlag: defaultSettings.hostName == 'http://139.224.249.160/api/' ? true : false
		};
	},
	mounted() {
		this.getPrepaidPage();
		this.indexQueryAgent(this.month);
	},
	methods: {
		handleRoute(name) {
			this.$router.push({
				name: name
			});
		},
		// 获取预付款额度
		getPrepaidPage() {
			let that = this;
			that.$request
				.post("prepaidPage", false, {
					pageNo: that.pageNo,
					pageSize: that.pageSize
				})
				.then(res => {
					that.infoList = res.data.list;
					that.total = res.data.totalCount;
				});
		},
		handleCurrentPage(val) {
			this.pageNo = val;
			this.getPrepaidPage();
		},
		// 店铺统计信息
		indexQueryAgent(dateTime) {
			this.$request
				.post("indexQueryAgent", false, {
					dateTime: dateTime
				})
				.then(res => {
					this.newCnt = res.data.newCnt;
					this.closeCnt = res.data.closeCnt;
					this.deliveryCnt = res.data.deliveryCnt;
					this.allCnt = res.data.allCnt;
				});
		},
		// 变更月份
		handleMonth(v) {
			console.log(
				`${v.getFullYear()}-${String(v.getMonth() + 1).padStart(2, 0)}`
			);
			this.indexQueryAgent(
				`${v.getFullYear()}-${String(v.getMonth() + 1).padStart(2, 0)}`
			);
		}
	}
};
</script>
<style lang="scss" scoped>
.home-content {
	height: 100%;
	box-sizing: border-box;
	padding: 10px 18px;
	.shop-box {
		position: relative;
		font-size: 14px;
		padding: 10px 15px;
		box-shadow: 0px 3px 5px 0px rgba(0, 0, 0, 0.3);
		z-index: 1;
		margin-bottom: 15px;
		background-color: #fff;
	}
	.home-grid {
		display: grid;
		// height: 100%;
		height: calc(100% - 90px) !important;
		grid-template-columns: 1fr 1fr 1fr 2fr;
		grid-gap: 20px 20px;
		.div {
			height: 100%;
			background-color: #fff;
			box-sizing: border-box;
			padding: 10px;
			.title {
				height: 32px;
				img {
					vertical-align: middle;
				}
			}
			.text {
				height: 32px;
				color: rgba(51, 51, 51, 1);
				margin-top: 10px;
				cursor: pointer;
				span {
					display: inline-block;
					width: 8px;
					height: 8px;
					border-radius: 8px;
					margin-left: 5px;
					margin-right: 5px;
					vertical-align: middle;
				}
				&:nth-child(odd) {
					span {
						background-color: rgba(27, 200, 180, 1);
					}
				}
				&:nth-child(even) {
					span {
						background-color: rgba(106, 142, 216, 1);
					}
				}
			}
		}
	}
}
.tips-box {
	padding: 0 5px 5px;
	// min-height: 300px;
}
.tips-item {
	font-size: 16px;
	font-weight: 400;
	color: #1c1a1d;
	border-bottom: 1px solid rgba($color: #1c1a1d, $alpha: 0.1);
	padding: 8px 0 !important;
	line-height: 22px;

	img {
		width: 26px;
		height: 23px;
	}
	.tips-time {
		min-width: 60px;
		font-size: 12px;
		font-weight: 400;
		color: #b7b4b8;
		text-align: right;
	}
}
.pdf-item {
	flex: 1;
	text-align: center;
	font-size: 14px;
	color: #666;
}
.pdf-img {
	width: 50px;
}
.code-img {
	width: 140px;
}
.tip-info-box {
	position: relative;
}
.pdf-box {
	width: 100%;
	position: absolute;
	bottom: 12px;
	left: 0;
}
.tips-content {
	width: 100%;
	position: absolute;
	bottom: 160px;
	left: 0;

	/deep/ .el-pagination.is-background .el-pager li:not(.disabled).active {
		background-color: #1bc9b5;
		color: #fff !important;
	}
	/deep/ .el-pager li:hover {
		color: #1bc9b5 !important;
	}
}
a {
	text-decoration: none;
	color: #666;
}
</style>
